/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TunnelVariableValideurDto } from './TunnelVariableValideurDto';
import {
    TunnelVariableValideurDtoFromJSON,
    TunnelVariableValideurDtoFromJSONTyped,
    TunnelVariableValideurDtoToJSON,
    TunnelVariableValideurDtoToJSONTyped,
} from './TunnelVariableValideurDto';
import type { CourtierValidationDto } from './CourtierValidationDto';
import {
    CourtierValidationDtoFromJSON,
    CourtierValidationDtoFromJSONTyped,
    CourtierValidationDtoToJSON,
    CourtierValidationDtoToJSONTyped,
} from './CourtierValidationDto';
import type { TunnelValideurDto } from './TunnelValideurDto';
import {
    TunnelValideurDtoFromJSON,
    TunnelValideurDtoFromJSONTyped,
    TunnelValideurDtoToJSON,
    TunnelValideurDtoToJSONTyped,
} from './TunnelValideurDto';

/**
 * Configuration de la validation des devis d'un tunnel.
 * @export
 * @interface GetTunnelValidationConfigResponse
 */
export interface GetTunnelValidationConfigResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetTunnelValidationConfigResponse
     */
    validationRequise: boolean;
    /**
     * Validation requise → au moins un valideur et un principal. Toujours true quand la validation n'est pas requise.
     * @type {boolean}
     * @memberof GetTunnelValidationConfigResponse
     */
    estComplete: boolean;
    /**
     * 
     * @type {Array<TunnelValideurDto>}
     * @memberof GetTunnelValidationConfigResponse
     */
    valideurs: Array<TunnelValideurDto>;
    /**
     * 
     * @type {Array<CourtierValidationDto>}
     * @memberof GetTunnelValidationConfigResponse
     */
    courtiers: Array<CourtierValidationDto>;
    /**
     * Variables du tunnel (contexte tunnel), triées par libellé, avec leur ouverture au valideur.
     * @type {Array<TunnelVariableValideurDto>}
     * @memberof GetTunnelValidationConfigResponse
     */
    variables: Array<TunnelVariableValideurDto>;
}

/**
 * Check if a given object implements the GetTunnelValidationConfigResponse interface.
 */
export function instanceOfGetTunnelValidationConfigResponse(value: object): value is GetTunnelValidationConfigResponse {
    if (!('validationRequise' in value) || value['validationRequise'] === undefined) return false;
    if (!('estComplete' in value) || value['estComplete'] === undefined) return false;
    if (!('valideurs' in value) || value['valideurs'] === undefined) return false;
    if (!('courtiers' in value) || value['courtiers'] === undefined) return false;
    if (!('variables' in value) || value['variables'] === undefined) return false;
    return true;
}

export function GetTunnelValidationConfigResponseFromJSON(json: any): GetTunnelValidationConfigResponse {
    return GetTunnelValidationConfigResponseFromJSONTyped(json, false);
}

export function GetTunnelValidationConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTunnelValidationConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'validationRequise': json['validationRequise'],
        'estComplete': json['estComplete'],
        'valideurs': ((json['valideurs'] as Array<any>).map(TunnelValideurDtoFromJSON)),
        'courtiers': ((json['courtiers'] as Array<any>).map(CourtierValidationDtoFromJSON)),
        'variables': ((json['variables'] as Array<any>).map(TunnelVariableValideurDtoFromJSON)),
    };
}

export function GetTunnelValidationConfigResponseToJSON(json: any): GetTunnelValidationConfigResponse {
    return GetTunnelValidationConfigResponseToJSONTyped(json, false);
}

export function GetTunnelValidationConfigResponseToJSONTyped(value?: GetTunnelValidationConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validationRequise': value['validationRequise'],
        'estComplete': value['estComplete'],
        'valideurs': ((value['valideurs'] as Array<any>).map(TunnelValideurDtoToJSON)),
        'courtiers': ((value['courtiers'] as Array<any>).map(CourtierValidationDtoToJSON)),
        'variables': ((value['variables'] as Array<any>).map(TunnelVariableValideurDtoToJSON)),
    };
}

